import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loadingCustomers: false,
  customers: [],
  totalCustomers: 0,
  error: null,
};

const route = "modules/workOrders/views/main/components/customerTab/redux/slice.";

const workOrdersSearchCustomers = createAsyncThunk(
  "workOrders/trackerTab/workOrdersSearchCustomers",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        workOrdersSearchCustomers.query,
        {
          conditions,
          sort,
          limit,
          offset: offset > -1 ? offset : 0,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchCustomers");
      return rejectWithValue(exc);
    }
  }
);

workOrdersSearchCustomers.query = `
    query ($conditions: [CustomerSearchInput], $sort: [CustomerSortInput], $limit: Int, $offset: Int) {
        data: searchCustomers(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
                ein
                contactId
                customerContact {
                  id
                  name
                  phone
                  email
                }
                locationId
                customerLocation {
                  id
                  name
                  contact
                  address
                  latitude
                  longitude
                }
                tagIds
                tags {
                  id
                  label
                  color
                }
            }
        }
    }
`;

export { workOrdersSearchCustomers };

//Slice
const workOrdersCustomerTabRedux = createSlice({
  name: "workOrders/customerTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //workOrdersSearchCustomers
    builder.addCase(workOrdersSearchCustomers.pending, (state) => {
      state.loadingCustomers = true;
    });
    builder.addCase(workOrdersSearchCustomers.fulfilled, (state, action) => {
      state.loadingCustomers = false;
      state.customers = action.payload.items;
      state.totalCustomers = action.payload.total;
    });
    builder.addCase(workOrdersSearchCustomers.rejected, (state, action) => {
      state.loadingCustomers = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCustomerTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
